import { getUsers } from "../../../services/stockJournal/user";

export default {
    namespaced: true,
    state: {
        users: []
    },
    getters: {
        users: state => state.users
    },
    mutations: {
        setUsers: (state, payload) => state.users = payload
    },
    actions: {
        fetchUsers: (context) => {
            return new Promise((resolve, reject) => {
                getUsers()
                    .then(response => {
                        context.commit("setUsers", response.data);
                        resolve(response);
                    })
                    .catch(error => reject(error))
            });
        }
    }
}